/**
 * apiErrorMessage — normalise any axios/FastAPI error into a
 * human-readable string safe to render directly in JSX.
 *
 * FastAPI 422 returns `detail` as List[dict]. Rendering that array
 * directly through {err} crashes React with "Objects are not valid
 * as a React child" and unmounts the surrounding route. Always run
 * caught errors through this helper before storing them in state.
 */
export function apiErrorMessage(err, fallback = "Something went wrong.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map(d => {
        if (typeof d === "string") return d;
        const loc = Array.isArray(d?.loc) ? d.loc.filter(x => x !== "body").join(".") : "";
        const msg = d?.msg || d?.message || JSON.stringify(d);
        return loc ? `${loc}: ${msg}` : msg;
      })
      .join("; ");
  }
  if (typeof detail === "object") {
    return detail.message || detail.msg || JSON.stringify(detail);
  }
  return String(detail);
}
